module.exports = __webpack_public_path__ + "static/media/Pattern4.28305b78.jpg";